import React from "react";
import { ArrowRight, Mail, MapPin, Phone } from "lucide-react";
import { CONTACT } from "../../data/content";
import { Reveal, WhatsAppIcon } from "../ui";

const CHANNELS = [
  { icon: Phone, label: "Call us", value: CONTACT.phoneDisplay, href: CONTACT.phoneHref },
  { icon: WhatsAppIcon, label: "WhatsApp", value: "Chat with our team", href: CONTACT.whatsapp, external: true },
  { icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}` },
  { icon: MapPin, label: "Office", value: CONTACT.location },
];

const Contact = () => (
  <section id="contact" className="section">
    <div className="container">
      <Reveal className="relative isolate overflow-hidden rounded-[2.5rem] border border-white/10 bg-ink-900 px-6 py-16 sm:px-12 lg:px-16 lg:py-20">
        <div className="absolute inset-0 -z-10 bg-grid bg-[size:40px_40px] [mask-image:radial-gradient(ellipse_at_center,black,transparent_70%)]" />
        <div className="absolute -bottom-40 left-1/2 -z-10 h-80 w-[40rem] -translate-x-1/2 rounded-full bg-brand-600/30 blur-[120px]" />

        <div className="grid gap-12 lg:grid-cols-2 lg:items-center">
          <div>
            <h2 className="h-section">
              Ready to secure <span className="text-accent">every entrance?</span>
            </h2>
            <p className="mt-5 max-w-lg text-lg leading-relaxed text-ink-300">
              Tell us about your site. We will show you KNTO Pass live and recommend the right readers and setup.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className="btn-primary btn-lg">
                Book a demo <ArrowRight className="h-4 w-4" />
              </a>
              <a href={`mailto:${CONTACT.email}`} className="btn-ghost btn-lg">
                Email us
              </a>
            </div>
          </div>

          <ul className="grid gap-3 sm:grid-cols-2">
            {CHANNELS.map(({ icon: Icon, label, value, href, external }) => {
              const body = (
                <>
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-600/10 text-brand-400 ring-1 ring-inset ring-brand-600/20">
                    <Icon className="h-5 w-5" />
                  </span>
                  <span className="mt-4 block text-sm text-ink-400">{label}</span>
                  <span className="mt-1 block break-words font-semibold text-white">{value}</span>
                </>
              );
              return (
                <li key={label}>
                  {href ? (
                    <a
                      href={href}
                      {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                      className="card card-hover block h-full p-6"
                    >
                      {body}
                    </a>
                  ) : (
                    <div className="card h-full p-6">{body}</div>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Contact;
